<app-button
  class="login-button"
  [customStyles]="{ 'border-radius': '8px', height: '40px' }"
  (click)="onLoginClick($event)"
  *ngIf="displayLoginButton()"
>
  <span>{{ 'public.global.login' | translate }}</span>
</app-button>
